import { render, staticRenderFns } from "./WaitingDots.vue?vue&type=template&id=c92f3cf6&lang=pug"
import script from "./WaitingDots.vue?vue&type=script&lang=js"
export * from "./WaitingDots.vue?vue&type=script&lang=js"
import style0 from "./WaitingDots.vue?vue&type=style&index=0&id=c92f3cf6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports